import { NONE } from '../../utils/constants';

export const normalizeOutcomesForContract = (outcomes) => {
  const userOutcomes = (outcomes ?? []).filter(
    (o) => o.label !== NONE && o.label !== 'Unclassified'
  );
  const userTotal = userOutcomes.reduce(
    (sum, o) => sum + Number(o.probability || 0),
    0
  );

  return [
    ...userOutcomes.map((o) => ({
      ...o,
      probability:
        userTotal > 0
          ? (Number(o.probability || 0) / userTotal) * 99
          : 99 / userOutcomes.length,
    })),
    { label: NONE, probability: 1 },
  ];
};

export const outcomesToBarValues = (outcomes) => {
  const barValues = outcomes.map((o) =>
    Math.floor(Number(o.probability || 0) * 100)
  );
  const total = barValues.reduce((sum, v) => sum + v, 0);
  const diff = 10000 - total;
  if (diff !== 0) {
    barValues[barValues.length - 1] += diff;
  }
  return barValues;
};
export const buildContractParams = ({
  isPublic,
  isResolverAi,
  smartAccount,
  zeroAddress,
  startTime,
  endTime,
  optionCount,
  disputeTimer,
  ipfsUrl,
  inputAmountWei,
  barValues,
  tokenAddress,
}) => [
  isPublic,
  isResolverAi,
  smartAccount,
  zeroAddress,
  startTime,
  endTime,
  optionCount,
  disputeTimer,
  ipfsUrl,
  inputAmountWei,
  barValues,
  smartAccount,
  tokenAddress,
];

export const buildCallArgs = ({
  usdtAllowance,
  rainAllowance,
  inputAmountWei,
  usdtToken,
  rainToken,
  factoryContract,
  bigNumberApproval,
  createPoolCallData,
  gasFeeCallData,
  approveEncode,
}) => {
  const calls = [];

  if (+usdtAllowance < +inputAmountWei) {
    calls.push({
      to: usdtToken,
      data: approveEncode(usdtToken, factoryContract, bigNumberApproval),
    });
  }
  if (+rainAllowance < +inputAmountWei) {
    calls.push({
      to: rainToken,
      data: approveEncode(rainToken, factoryContract, bigNumberApproval),
    });
  }

  calls.push({ to: factoryContract, data: createPoolCallData });
  calls.push({ to: usdtToken, data: gasFeeCallData });

  return calls;
};

export const normalizeApiOutcomes = (rawOutcomes) => {
  let filtered = rawOutcomes.filter(
    (o) => o.label !== 'Unclassified' && o.label !== NONE
  );

  if (filtered.length === 0) {
    filtered = [
      { id: '1', label: 'Yes', color: 'hsl(var(--probability-yes))' },
      { id: '2', label: 'No', color: 'hsl(var(--probability-no))' },
    ];
  }

  const equalShare = Math.floor(99 / filtered.length);
  const remainder = 99 - equalShare * filtered.length;

  return [
    ...filtered.map((o, i) => ({
      ...o,
      probability: i === 0 ? equalShare + remainder : equalShare,
    })),
    {
      id: 'unclassified',
      label: 'Unclassified',
      probability: 1,
      isUnclassified: true,
      locked: true,
      color: 'hsl(var(--muted-foreground))',
    },
  ];
};

export const buildAutocompleteOutcomes = (options) => {
  const equalShare = Math.floor(99 / options.length);
  const remainder = 99 - equalShare * options.length;

  const outcomes = options.map((opt, i) => ({
    id: String(i + 1),
    label: opt,
    probability: i === 0 ? equalShare + remainder : equalShare,
    color:
      i === 0
        ? 'hsl(var(--probability-yes))'
        : i === 1
          ? 'hsl(var(--probability-no))'
          : `hsl(${45 + i * 60} 93% 47%)`,
  }));

  outcomes.push({
    id: 'unclassified',
    label: 'Unclassified',
    probability: 1,
    isUnclassified: true,
    locked: true,
    color: 'hsl(var(--muted-foreground))',
  });

  return outcomes;
};
